import { render } from "./TwoFaResetCodeConfirmCopy.vue?vue&type=template&id=727d0a5a"
import script from "./TwoFaResetCodeConfirmCopy.vue?vue&type=script&lang=js"
export * from "./TwoFaResetCodeConfirmCopy.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent02/user/3807/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__